import { xhrClient } from '../../../config/axiosClient'

const postLanguageCheck = async (payload: any, plop: any) => {
    if (!Boolean(plop?.options?.context?.checkLanguage)) {
        return true
    }

    const { data } = await xhrClient.post(`/api/language-check`, {
        words: payload,
    })

    return !data.words
}

export default postLanguageCheck
